import { jsx, jsxs } from "react/jsx-runtime";
import { Flex, Image, Typography, Grid } from "antd";
const { Text } = Typography;
const { useBreakpoint } = Grid;
const TeamComponent = ({ rowData, token }) => {
  const screens = useBreakpoint();
  const iconSize = screens.md ? 24 : 20;
  return /* @__PURE__ */ jsxs(Flex, { align: "center", gap: screens.md ? 12 : 8, children: [
    /* @__PURE__ */ jsx(
      Image,
      {
        src: rowData.teamIcon,
        alt: rowData.teamName,
        width: iconSize,
        height: iconSize,
        style: { objectFit: "contain", flexShrink: 0 },
        preview: false
      }
    ),
    /* @__PURE__ */ jsx(
      Text,
      {
        className: "truncate-line",
        style: {
          color: token.colorTextBase,
          fontSize: screens.md ? token.fontSize : token.fontSizeSM,
          fontWeight: screens.md ? 700 : 500,
          textAlign: "left"
        },
        children: rowData.teamName
      }
    )
  ] });
};
var stdin_default = TeamComponent;
export {
  stdin_default as default
};
